// Ported from monorepo/src/components/corpus/challenge-score-badge.tsx.
// Same thresholds and title; restyled onto the catalog palette — the score
// is a stamped mono figure, not a pill of arbitrary color.
import { cn } from "@bindery/ui/lib/utils";

interface ChallengeScoreBadgeProps {
  score: number;
  className?: string;
}

/**
 * Badge showing the challenge score. Thresholds unchanged from the source:
 * strong (>80) / middling (60–80) / weak (<60).
 */
export function ChallengeScoreBadge({
  score,
  className,
}: ChallengeScoreBadgeProps) {
  const rounded = Math.round(score);

  const colorClass =
    rounded > 80
      ? "border-primary/40 bg-accent text-accent-foreground"
      : rounded >= 60
        ? "border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-200"
        : "border-red-300 bg-red-50 text-red-900 dark:border-red-800 dark:bg-red-950 dark:text-red-200";

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-sm border px-1.5 py-0.5 font-mono text-xs font-medium tabular-nums",
        colorClass,
        className,
      )}
      title={`Challenge score: ${rounded}/100`}
    >
      {rounded}
    </span>
  );
}
